import { Navigate } from "react-router-dom";
import { usePortal } from "@app/portal-sdk";
import { Alert, Box, Button } from "@app/ui-kit";
import { LoadingScreen } from "../components/LoadingScreen";

/**
 * Landing route. Sends the caller to the right place:
 *   bkdp-admin → /admin · one client → /c/:slug · several → /select · none → /no-access
 */
export const Resolver = () => {
  const { loading, error, refresh, isBkdpAdmin, memberships } = usePortal();

  if (loading) {
    return <LoadingScreen />;
  }

  if (error) {
    return (
      <Box sx={{ maxWidth: 520 }}>
        <Alert
          severity="error"
          action={
            <Button color="inherit" size="small" onClick={() => void refresh()}>
              Retry
            </Button>
          }
        >
          {error}
        </Alert>
      </Box>
    );
  }

  if (isBkdpAdmin) {
    return <Navigate to="/admin" replace />;
  }

  const active = memberships.filter((m) => m.status === "active" && m.client.status === "active");
  if (active.length === 1) {
    return <Navigate to={`/c/${active[0].client.slug}`} replace />;
  }
  if (active.length > 1) {
    return <Navigate to="/select" replace />;
  }
  return <Navigate to="/no-access" replace />;
};
